import { SearchFilterTypeEnumLowercase } from "@components/atoms/Filters/utils";
import { IconsType, IconsVariant } from "@components/icons/VDBIcon";
import { SearchResultsAndFavoritesEnum } from "@utils/product/searchResultConstants";
import { VDBIcons } from "@utils/VDBIcons";

export const filterMenuOptions = (menuOptions: any[], userInfo: any) => {
  if (userInfo.isIFrame()) {
    return menuOptions.filter(
      (option) =>
        option.name !== SearchResultsAndFavoritesEnum.SHARE_EMAIL &&
        option.name !== SearchResultsAndFavoritesEnum.SHARE_NATIVE &&
        option.name !== SearchResultsAndFavoritesEnum.SHARE_MEDIA &&
        option.name !== SearchResultsAndFavoritesEnum.ADD_TO_COLLECTION &&
        option.name !== SearchResultsAndFavoritesEnum.ADD_TO_FAVORITES &&
        option.name !== SearchResultsAndFavoritesEnum.ADD_TO_BULK_REQUEST &&
        option.name !== SearchResultsAndFavoritesEnum.REMOVE_FROM_BULK_REQUEST
    );
  }
  return menuOptions;
};

export const filterRequestOptions = (
  menuOptions: any[],
  excludeCartAndBuyNow = true
) => {
  return menuOptions.filter(
    (option) =>
      option.name !== SearchResultsAndFavoritesEnum.ADD_TO_BULK_LIST &&
      option.name !== SearchResultsAndFavoritesEnum.REMOVE_FROM_BULK_REQUEST &&
      option.name !== SearchResultsAndFavoritesEnum.ADD_TO_BULK_REQUEST &&
      option.name !== SearchResultsAndFavoritesEnum.REQUEST_ITEMS &&
      option.name !== SearchResultsAndFavoritesEnum.BUY_ITEMS &&
      option.name !== SearchResultsAndFavoritesEnum.MEMO_ITEMS &&
      option.name !== SearchResultsAndFavoritesEnum.HOLD_ITEMS &&
      (!excludeCartAndBuyNow ||
        option.name !== SearchResultsAndFavoritesEnum.ADD_TO_CART) &&
      (!excludeCartAndBuyNow ||
        option.name !== SearchResultsAndFavoritesEnum.BUY_NOW)
  );
};

export const consolidatedStoneTypesIcons = (consolidatedStoneTypes: any) => {
  return {
    [SearchFilterTypeEnumLowercase.PAIRS]: {
      data:
        consolidatedStoneTypes?.icons?.[SearchFilterTypeEnumLowercase.PAIRS]
          ?.data || VDBIcons.FIND_A_MATCH,
      type:
        consolidatedStoneTypes?.icons?.[SearchFilterTypeEnumLowercase.PAIRS]
          ?.type === IconsType.img_url
          ? IconsVariant.CustomUrl
          : IconsVariant.VDBCustom,
    },
    [SearchFilterTypeEnumLowercase.PARCEL]: {
      data:
        consolidatedStoneTypes?.icons?.[SearchFilterTypeEnumLowercase.PARCEL]
          ?.data || VDBIcons.PARCELS,
      type:
        consolidatedStoneTypes?.icons?.[SearchFilterTypeEnumLowercase.PARCEL]
          ?.type === IconsType.img_url
          ? IconsVariant.CustomUrl
          : IconsVariant.VDBCustom,
    },
    [SearchFilterTypeEnumLowercase.SINGLE_STONES]: {
      data:
        consolidatedStoneTypes?.icons?.[
          SearchFilterTypeEnumLowercase.SINGLE_STONES
        ]?.data || VDBIcons.UPD_DIAMONDS,
      type:
        consolidatedStoneTypes?.icons?.[
          SearchFilterTypeEnumLowercase.SINGLE_STONES
        ]?.type === IconsType.img_url
          ? IconsVariant.CustomUrl
          : IconsVariant.VDBCustom,
    },
  };
};
